import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  selector: 'app-email-logs',
  templateUrl: './email-logs.component.html',
  styleUrls: ['./email-logs.component.scss']
})
export class EmailLogsComponent implements OnInit {
  columnsToDisplay: any = ['accepted', 'rejected', 'subject', 'messageId', 'envelope', 'action', 'action_date'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  isLoading: boolean;
  pageTitle = 'Αρχείο αποστολών email από το eApply';
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  constructor(public toastMessagesService: ToastMessagesService,
              private commonService: CommonService,
              public excelService: ExcelService) {
    this.isLoading = false;
  }

  async ngOnInit() {
    try {
      const request: any = await this.commonService.getList('college/send-email-logs');
      const records = request.object;
      this.dataSource = new MatTableDataSource<any>(records);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.commonService.setPaginatorTexts(this.paginator);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Κάτι δεν πήγε καλά με την φόρτωση των δεδομένων');
    }
  }

  exportToExcel() {
    const {records, columns} = this.formatModel();
    this.excelService.exportAsCustomExcelFile(records, 'Ενέργειες εισόδου', columns);
  }

  search(value: any) {
    const searchValue = value.toLowerCase().trim();
    this.dataSource.filter = searchValue;
  }

  formatModel() {
    const records = [];
    for (const record of this.dataSource.data) {
      const model = {
        name: record.name,
        action_date: record.action_date_time,
        action: record.action,
        action_description: record.action_description
      };
      records.push(model);
    }

    const columns = [{
      key: 'name',
      label: 'Αναγνωριστικό',
    },
      {
        key: 'action_date',
        label: 'Ημερομηνία ενέργειας',
      },
      {
        key: 'action',
        label: 'Ενέργεια',
      },
      {
        key: 'action_description',
        label: ' Περιγραφή ενέργειας',
      }];

    return {records, columns};
  }
}
